import { Injectable } from '@angular/core';
import { ComponentService } from '../service/component.service';

@Injectable({
  providedIn: 'root',
})
export class DealerPriceCheckerService {
  constructor(private componentService: ComponentService) {}

  dealerPriceLoaderStartTimer(timeLeft: any) {
    setInterval(() => {
      if (timeLeft > 0) {
        timeLeft--;
        if (timeLeft === 1) {
          timeLeft = 0;
          this.componentService.sethasDealerPrice(false);
        }
      }
    }, 1000);
  }
}
